<template>
    <div class="order">
        <van-nav-bar
            title="我的订单"
            left-arrow
            @click-left="onClickBack"
            :fixed='true'
        />
        <div class="order-search">
            <van-search placeholder="请输入证件号" 
                left-icon='idcard'            
            v-model="search.psptId" />
            <van-search
                v-model="search.custName"
                placeholder="请输入姓名"
                show-action
                left-icon='phone-o'
                shape="round"
                @search="onSearch"
                >
                <div slot="action" style="color:#25C973;" @click="onSearch(true)">搜索</div>
            </van-search>
        </div>
        <div class="order-list">
             <van-list
                v-model="loading"
                :finished="finished"
                finished-text="亲,人家也是有底线的..."
                error-text="请求失败，点击重新加载"
                :error.sync="loadError"
                :immediate-check=false
                @load="onLoad"
                >
                 <van-collapse class="order-list-collapse" v-for="(item,index) in orderList"  v-bind:key='index' v-model="activeNames">
                    <van-collapse-item 
                        title-class='order-panel-collapse-title' value-class='order-panel-collapse-value' :title="item.orderCode" :value="item.status" :name="index">
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value'
                            size='large'
                            title="购买号码"
                            :value="item.serialNumber">
                        </van-cell>
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value'
                            size='large'
                            title="配置套餐"
                            :value="item.packageName">
                        </van-cell>
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value-money'
                            size='large'
                            title="预存费"
                            :value="'￥'+item.baseFee/100">
                        </van-cell>
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value-money'
                            size='large'
                            title="快递费"
                            :value="'￥'+item.payLogistics/100">
                        </van-cell>
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value'
                            size='large'
                            title="下单时间"
                            :value="item.createTime">
                        </van-cell>
                        <van-cell
                            title-class='order-list-cell-title'
                            value-class='order-list-cell-value-money'
                            size='large'
                            title="需付金额"
                            :value="'￥'+item.fee/100">
                        </van-cell>
                        <div class="order-list-cell-btnContiner">
                            <span class="order-list-cell-btnContiner-cancel" v-if="item.canCancel" >
                                <van-button size='small' type="danger" hairline plain round @click='cancelOrder(item)'>取消订单</van-button>
                            </span>
                            <span class="order-list-cell-btnContiner-toPay" v-if="item.canPay">
                                <van-button size='small' type="primary" hairline plain round @click='toPay(item)'>继续支付</van-button>
                            </span>
                            <span class="order-list-cell-btnContiner-more">
                                <van-button size='small' hairline plain round @click='goOrderFlow(item)'>更多信息</van-button>
                            </span>
                        </div>
                    </van-collapse-item>
                </van-collapse>
             </van-list>
           
        </div>
  </div>
</template>

<script>
import {setAesString} from "../../config/date";

export default {
    name: 'order',
    created(){
        // Toast('提示内容');
    },
    data(){
        return{
            search:{
                custName:'',
                psptId:''
            },
            loading: false,
            loadError:false,
            finished: false,
            activeNames:[],
            orderList: [],
            page: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
                paging: "1",
            }
        }
    },
    methods: {
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                this.onSearch(false);       
                this.page.pageNum = this.page.pageNum + 1;
            }, 500);
        },
        goOrderFlow(obj){
            if(obj == null){
                this.$toast({
                    message: '请选择需要查看的订单',
                    icon: 'fail'
                });
                return;
            }
            sessionStorage.setItem(setAesString("orderCode"),setAesString(obj.orderCode));
            this.$router.push({
                path:'/orderFlow'
            });
        },
        cancelOrder(obj){
            //取消订单
            if(obj == null){
                this.$toast({
                    message: '请选择需要取消的订单',
                    icon: 'fail'
                });
                return;
            }
            var formdata = {
                service:'user.cancelChoiceNumberOrder',
                orderCode:obj.orderCode
            }
             this.$dialog.confirm({
                message: '确认取消订单?'
            }).then(() => {
               this.$api.post("/mstx/pr/gateway.do", formdata,()=>{
                    // 加载状态结束
                    this.$toast.success("订单取消成功,正在退款...");
                    this.onSearch(true);
                },(res)=>{
                    this.$toast.fail(res.errorMsg);
                });
            }).catch(() => {
            });
            

        },
        toPay(obj){
            //继续支付
            if(obj == null){
                this.$toast({
                    message: '请选择需要支付的订单',
                    icon: 'fail'
                });
                return;
            }
            sessionStorage.setItem(setAesString("orderInfo"),setAesString(JSON.stringify(obj)));
            sessionStorage.setItem(setAesString("continuePay"),setAesString('true'));
            this.$router.push({
                path:'/needPayInfo'
            });

        },
        onSearch(reset){
            if(reset){
                this.orderList=[];
            }

            if(this.search.custName == ''){
                 this.$toast({
                    message: '请输入姓名',
                    icon: 'fail'
                });
                return;
            }
            if(this.search.psptId == '' || this.search.psptId.length != 18){
                 this.$toast({
                    message: '请输入有效证件号',
                    icon: 'fail'
                });
                return;
            }

            var formdata = {
                ...this.page,
                service:'user.qryChoiceNumberOrder',
                psptId:this.search.psptId,
                custName:this.search.custName
            }
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.loadError = false;
                // 加载状态结束
                this.loading = false;
               if(res != null && res.list.length > 0){
                   for(var i = 0; i < res.list.length; i++){
                        this.orderList.push(res.list[i]);
                        this.activeNames.push(i);
                   }
                   if(res.list.length < this.page.pageSize){
                        this.finished = true;
                        this.page.pageNum = 1;
                    }
               }else{
                    if( this.page.pageNum == 1){
                        this.$toast.fail("暂无您的订单信息...");
                    }
                    this.page.pageNum = 1;
                    this.finished = true;
               }
            },(res)=>{
                this.$toast.fail(res.errorMsg);
                this.page.pageNum =  this.page.pageNum - 1;
                this.loading = false;
                this.finished = false;
                this.loadError = true;
            });
        }
  }
}
</script>

<style lang="less">

.order{
    &-search{
        margin-top: 47px;
    }
    &-state{
        margin-top: 10px;
    }
    &-list{
        &-collapse{
            margin: 10px 5px;
        }
        &-cell{
            &-btnContiner{
                margin: 10px 10px;
                height: 20px;
                &-cancel{
                    button{
                        color: red !important;
                    }
                }
                &-toPay{
                    margin-left: 15px;
                    button{
                        color: #25C973 !important;
                    }
                }
                &-more{
                    float: right;

                }
            }
            &-title{
                text-align: left;
                color: rgb(145, 143, 143);
            }
            &-value{
                text-align: right;
                &-money{
                    color:red !important;
                }
            }
        }
    }
    &-panel{
        &-collapse{
            &-title{
                font-size: 12px;
            }
            &-value{
                font-size: 12.5px;
            }
        }
    }
}
</style>
